import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { CheckBoxOptions, ControlLayout, DropdownOptions, FilterItem, FilterType, InputType, PagingOptions, RadioButtonOptions, TextAreaOptions, TextBoxOptions, RadioButtonItem, FormOptions } from 'bnsights-control-library';
import { ProviderService } from '../../shared/Services/provider.service';
import { ProviderModel } from '../../shared/models/ProviderModels/ProviderModel';
import { ProviderAttributeModel } from '../../shared/models/ProviderModels/ProviderAttributeModel';
import { DefaultProviderModel } from '../../shared/models/ProviderModels/DefaultProviderModel';
import { PageInfoService } from '../../../_metronic/core/services/page-info.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthService, UtilityService, BBSFTranslateService, EnvironmentService } from 'bnsights-utilities-library';
import { Observable } from 'rxjs';
import { PagingComponent } from 'bnsights-control-library/lib/controls/Paging/Paging.component';


@Component({
  selector: 'lib-provider',
  templateUrl: './provider.component.html'
})
export class ProviderComponent implements OnInit {
  //Page requirements
  ShowPageContent: boolean = false;
  ProductionMode: boolean = false;
  language: string = ""
  ApiUrl = "/api/admin/Provider/";


  //Filter and paging components
  ProviderForm = new FormGroup({});
  searchTextBox: TextBoxOptions;
  TextInputFilter: FilterItem;
  providerTypesFilterOption: DropdownOptions;
  providerTypesFilter: FilterItem;
  sortingFilterOption: DropdownOptions;
  sortingFilter: FilterItem;
  IsFilterLoaded: boolean = false;
  IsFilterDataLoaded: boolean = false;
  ProviderPaging: PagingOptions;
  ProviderPagingResult: any[] = [];
  @ViewChild('ProviderPagingViewElement', { static: false }) pagingElement: PagingComponent;

  //Required lists
  ProviderTypesFilterList: any[] = [];
  SortingFilterList: any[] = [];
  TypesList: any[] = [];
  LoadedProviders: any[] = [];
  OrganizationsList = [];
  @ViewChild('providerTypesDDL', { static: false }) providerTypesDDL: ElementRef;
  @ViewChild('sortingFilterDDL', { static: false }) sortingFilterDDL: ElementRef;


  //Provider attributes
  ProviderAttributesOptions: any[] = [];
  ProviderAttributesCount:number=0;
  IsAttributesLoaded:boolean=false;


  //Add Model Controls
  AddProviderForm = new FormGroup({});
  AddProviderFormOptions: FormOptions
  AddName: TextBoxOptions;
  AddDescription: TextAreaOptions;
  AddOrganizationOptions: DropdownOptions;
  AddTypeOptions: DropdownOptions;
  AddProviderTypeItemID: number = 0;
  @ViewChild('CloseAddProviderModal', { static: false }) CloseAddProviderModal: ElementRef;

  ////Edit Model Controls
  EditProviderForm = new FormGroup({});
  EditProviderFormOptions: FormOptions
  EditName: TextBoxOptions;
  EditDescription: TextAreaOptions;
  EditTypeOptions: DropdownOptions;
  EditProviderTypeItemID: number = 0;
  EditProviderOrganizationID: number=0;
  EditProviderAttributesOptions: any[] = [];
  EditProviderAttributesCount: number = 0;
  ProviderId: number;
  @ViewChild('CloseEditProviderModal', { static: false }) CloseEditProviderModal: ElementRef;

  //delete  Model Controls
  deleteProviderId: string;
  @ViewChild('CloseDeleteProviderModal', { static: false }) CloseDeleteProviderModal: ElementRef;

  //Select Default Providers
  DefaultProviderForm = new FormGroup({});
  DefaultProviderFormOptions: FormOptions
  DefaultProviders: any[] = [];
  DefaultProvidersRadioBtnOptions: RadioButtonOptions[];
  @ViewChild('CloseDefaultProviderModal', { static: false }) CloseDefaultProviderModal: ElementRef;

  constructor
    (
    private environmentService: EnvironmentService,
    private ProviderService: ProviderService,
    private modalService: NgbModal,
    private authService: AuthService,
    private bbsfTranslateService: BBSFTranslateService,
    public utilityService: UtilityService,
    private pageInfoService: PageInfoService
    ) {}



  async ngOnInit(): Promise<void> {
    this.ShowPageContent = true;
    //Page header (breadcrumb and title)
    PageInfoService.PageTitle=this.utilityService.getResourceValue("ServiceProviders")
    PageInfoService.PageBreadcrumbs=[
       {title: this.utilityService.getResourceValue("Home") , path: '/Admin/Home', isSeparator: false, isActive: false},
       {title: '', path: '', isSeparator: true, isActive: false}

    ];
    this.pageInfoService.calculateTitle();
    this.pageInfoService.calculateBreadcrumbs();

    //set language and production mode
    this.bbsfTranslateService.onLangChange.subscribe((event)=>{
      this.ShowPageContent=false;
      this.language = event.lang;
      this.ngOnInit();
    })
    this.language =  await this.utilityService.getCurrentLanguage();
    this.ProductionMode = this.environmentService.getProductionMode();

    //initialize page
    this.initializePage();
  }

  //Initialize filters and paging
  initializePage() {
    // TextBox inti
    this.searchTextBox = new TextBoxOptions();
    this.searchTextBox.Name = "searchTextBox"
    this.searchTextBox.Type = InputType.Text
    this.searchTextBox.Placeholder = this.utilityService.getResourceValue("SearchByName")
    this.searchTextBox.HideLabel = true

    this.TextInputFilter = new FilterItem();
    this.TextInputFilter.FormControlName = "searchTextBox"
    this.TextInputFilter.ActionParameterName = "searchText"
    this.TextInputFilter.IsFormControl = true
    this.TextInputFilter.FilterType = FilterType.TextBox

    // Provider Types Filter Init   
    this.providerTypesFilterOption = new DropdownOptions();
    this.providerTypesFilterOption.Name = "providerTypesFilterOption"
    this.providerTypesFilterOption.LabelKey = "ProviderTypes"
    this.providerTypesFilterOption.Placeholder = this.utilityService.getResourceValue("ServiceProviderType");

    this.providerTypesFilter = new FilterItem();
    this.providerTypesFilter.FormControlName = "providerTypesFilterOption"
    this.providerTypesFilter.ActionParameterName = "types"
    this.providerTypesFilter.IsFormControl = true
    this.providerTypesFilter.FilterType = FilterType.DropdownList


    this.sortingFilterOption = new DropdownOptions();
    this.sortingFilterOption.Name = "sortingFilterOption"
    this.sortingFilterOption.LabelKey = "Sort"
    this.sortingFilterOption.SingleSelection = true;
    this.sortingFilterOption.Placeholder = "";

    this.sortingFilter = new FilterItem();
    this.sortingFilter.FormControlName = "sortingFilterOption"
    this.sortingFilter.ActionParameterName = "sortID"
    this.sortingFilter.IsFormControl = true
    this.sortingFilter.FilterType = FilterType.DropdownList;


    this.ProviderPaging = new PagingOptions();
    this.ProviderPaging.ActionPostURL = this.environmentService.getApiUrl() + this.ApiUrl + 'GetProvidersByFilter';
    this.ProviderPaging.OnKeyPressFiltersControlNames = ["searchTextBox"];
    this.ProviderPaging.DropdownFiltersControlNames = ["providerTypesFilterOption", "sortingFilterOption"];
    this.ProviderPaging.Filters = [this.TextInputFilter, this.providerTypesFilter, this.sortingFilter]
    this.ProviderPaging.ValidationToken = this.authService.authorizationHeaderValue();

    this.IsFilterLoaded = true;
  }

  //Load filters lists
  loadLists() {
    if (!this.IsFilterDataLoaded) {
      this.ProviderService.Loaddropdowns().subscribe((result) => {
        let DropdownLists = result as any
        //this.OrganizationsList = DropdownLists.organizations;
        //this.TypesList = DropdownLists.providerTypes;
        this.ProviderTypesFilterList = DropdownLists.providerTypesFilter;
        this.SortingFilterList = DropdownLists.sortingFilterList;

        let providerTypesElement = this.providerTypesDDL as any;
        let sortingFilterElement = this.sortingFilterDDL as any;


        providerTypesElement.UpdateDataSource(this.ProviderTypesFilterList);

        sortingFilterElement.UpdateDataSource(this.SortingFilterList);


        this.IsFilterDataLoaded = true;
      });
    }
  }

  //Paging functions
  setProviderListResult(result) {
    this.ProviderPagingResult = result;
    this.ShowPageContent=true;
    this.utilityService.stopBlockUI()
  }
  resetFilters() {
    this.ProviderForm.controls["providerTypesFilterOption"].setValue([]);
    this.ProviderForm.controls["sortingFilterOption"].setValue([]);
    this.ProviderForm.controls["searchTextBox"].setValue(null);
    let element = this.pagingElement as any;
    element.ReinitializePaging();
  }

  //AttributesFunction
  setAddProviderAttributes(typeFullName){
    this.ProviderService.GetProviderAttributes(typeFullName).subscribe((result) => {
      var resultObj = result as any;
      //Set Provider type id on type change
      this.LoadedProviders = resultObj.loadedProviders;
      let selectedProviderType = this.LoadedProviders.find(obj => {
        return obj.fullName === typeFullName
      });
      this.AddProviderTypeItemID = selectedProviderType.providerType;

      //Set attributes and count
      let attributes = resultObj.model;
      this.ProviderAttributesOptions = [];
      let data: any = this.getProviderAttributesOptions(attributes, true);
      this.ProviderAttributesOptions = data[0];
      this.ProviderAttributesCount = data[1];
      this.IsAttributesLoaded = true;

      }, (error) => {
      })
}

  setEditProviderAttributes(typeFullName) {
    debugger;
    this.ProviderService.GetProviderAttributes(typeFullName).subscribe((result) => {
      var resultObj = result as any;
      //Set Provider type id on type change
      this.LoadedProviders = resultObj.loadedProviders;
      let selectedProviderType = this.LoadedProviders.find(obj => {
        return obj.fullName === typeFullName
      });
      this.EditProviderTypeItemID = selectedProviderType.providerType;

      //Set attributes and count
      let attributes = resultObj.model;
      this.EditProviderAttributesOptions = [];
      let data: any = this.getProviderAttributesOptions(attributes, false);
      this.EditProviderAttributesOptions = data[0];
      this.EditProviderAttributesCount = data[1];

    }, (error) => {
    })
  }

  getProviderAttributesOptions(providerAttributes: any[], isAdd: boolean) {
    let attributesOptions: any[] = [];
    let attributesCount: number = 0;
    let actionIndicate: string = isAdd ? "Add" : "Edit";
    for (let i = 0; i < providerAttributes.length; i++) {

      let objectAttributeOptions: any[] = [];
      let isEncrypted: boolean = providerAttributes[i].isEncrypted;

      let AttributeName = new TextBoxOptions();
      AttributeName.Name = actionIndicate + "AttributeName" + i;
      AttributeName.HideLabel = true;
      AttributeName.Type = InputType.Text;
      AttributeName.Value = providerAttributes[i].name;


      let AttributeValue = new TextBoxOptions();
      AttributeValue.Name = actionIndicate + "AttributeValue" + i;
      AttributeValue.HideLabel = true;
      AttributeValue.Type = isEncrypted ? InputType.Password : InputType.Text;
      AttributeValue.Value = providerAttributes[i].value;
      AttributeValue.RemoveDefaultPasswordValidation = true;

      let AttributeEncrypted = new CheckBoxOptions();
      AttributeEncrypted.Name = actionIndicate + "AttributeEncrypted" + i;
      AttributeEncrypted.Value = providerAttributes[i].isEncrypted;

      objectAttributeOptions.push(AttributeName, AttributeValue, AttributeEncrypted);
      attributesOptions.push(objectAttributeOptions);
      attributesCount += 1;

    }
    return [attributesOptions, attributesCount];
  }

  deleteAttribute(deletedAttribute: any, isAdd: boolean) {
    debugger;
    if (isAdd) {
      let deletedAttrIndex: number = this.ProviderAttributesOptions.indexOf(deletedAttribute);
      if (deletedAttrIndex !== -1) {
        this.ProviderAttributesOptions.splice(deletedAttrIndex, 1);
        for (var i = 0; i < deletedAttribute.length; i++) {
          this.AddProviderForm.removeControl(deletedAttribute[i].Name);
        }
      }
    }
    else {
      let deletedAttrIndex: number = this.EditProviderAttributesOptions.indexOf(deletedAttribute);
      if (deletedAttrIndex !== -1) {
        this.EditProviderAttributesOptions.splice(deletedAttrIndex, 1);
        for (var i = 0; i < deletedAttribute.length; i++) {
          this.EditProviderForm.removeControl(deletedAttribute[i].Name);
        }
      }
    }
  }

  encryptedChange(isChecked, option, isAdd) {
    let valueAttributeIndicator = isAdd ? "AddAttributeValue" : "EditAttributeValue";
    let realtedValueOption = option.find(obj => {
      return obj.Name.startsWith(valueAttributeIndicator)
    });
    if (isChecked)
      realtedValueOption.Type = InputType.Password;
    else
      realtedValueOption.Type = InputType.Text;

  }


  //Add provider
  showAddProviderModal(addProviderModal) {
    this.utilityService.startBlockUI();
    this.ProviderService.LoaddropdownsForAdd().subscribe((result) => {
      let resultObj = result as any;
      this.OrganizationsList = resultObj.organizations;
      this.TypesList = resultObj.providerTypes;

      this.ProviderAttributesOptions = [];
      this.ProviderAttributesCount = 0;
      this.IsAttributesLoaded = false;

      this.AddProviderForm = new FormGroup({})

      this.AddProviderFormOptions = new FormOptions();
      this.AddProviderFormOptions.FormGroup = this.AddProviderForm
      this.AddProviderFormOptions.GetModelFunction = this.getAddProviderModel;
      this.AddProviderFormOptions.ServiceSubmitFunction = this.getAddProviderFunction;
      this.AddProviderFormOptions.PagingReference = this.pagingElement

      this.AddName = new TextBoxOptions();
      this.AddName.Name = "AddName";
      this.AddName.LabelKey = "ProviderName";
      this.AddName.Type = InputType.Text;
      this.AddName.Value = null;
      this.AddName.IsRequired = true;


      this.AddDescription = new TextAreaOptions();
      this.AddDescription.Name = "AddDescription";
      this.AddDescription.LabelKey = "ProviderDescription";
      this.AddDescription.Value = null;

      this.AddOrganizationOptions = new DropdownOptions();
      this.AddOrganizationOptions.Name = "AddOrganizationOptions"
      this.AddOrganizationOptions.LabelKey = "Organization"
      this.AddOrganizationOptions.DataSource = this.OrganizationsList
      this.AddOrganizationOptions.SingleSelection = true;
      this.AddOrganizationOptions.AllowSearchFilter = true;
      this.AddOrganizationOptions.Placeholder = "";
      this.AddOrganizationOptions.IsRequired = true;

      this.AddTypeOptions = new DropdownOptions();
      this.AddTypeOptions.Name = "AddTypeOptions"
      this.AddTypeOptions.LabelKey = "ProviderType"
      this.AddTypeOptions.DataSource = this.TypesList
      this.AddTypeOptions.SingleSelection = true;
      this.AddTypeOptions.AllowSearchFilter = true;
      this.AddTypeOptions.Placeholder = "";
      this.AddTypeOptions.IsRequired = true;
      this.modalService.open(addProviderModal);
      this.utilityService.stopBlockUI();
    });
    

  }
  getAddProviderModel = () => {
    let paramArray: any[] = [];
    let ResultModel = this.AddProviderForm.value;
    let AddModel: ProviderModel = new ProviderModel();
    AddModel.ProviderName = ResultModel.AddName;
    AddModel.Description = ResultModel.AddDescription;
    let orgArr = ResultModel.AddOrganizationOptions;
    let organizationID: number;
    organizationID = Number(orgArr);

    AddModel.OrganizationID = ResultModel.AddOrganizationOptions != null ? organizationID : null;
    AddModel.ProviderTypeItemID = this.AddProviderTypeItemID;
    AddModel.TypeFullName = ResultModel.AddTypeOptions;
    for (let j = 0; j < this.ProviderAttributesCount; j++) {
      let addAttributeName = ResultModel["AddAttributeName" + j];
      // if (isUndefined(addAttributeName))
      //   continue;

      let addAttributeValue = ResultModel["AddAttributeValue" + j];
      let addAttributeEncrypted = ResultModel["AddAttributeEncrypted" + j];

      let providerAttr: ProviderAttributeModel = new ProviderAttributeModel();
      providerAttr.Name = addAttributeName;
      providerAttr.Value = addAttributeValue;
      providerAttr.IsEncrypted = addAttributeEncrypted;
      AddModel.ProviderAttributes.push(providerAttr);
    }

    paramArray.push(AddModel);
    return paramArray;
  }

  getAddProviderFunction = (AddModel): Observable<any> => {
    return this.ProviderService.AddProvider(AddModel)
  }

 //Edit provider
  showEditProviderModal(providerID: number, providerIDEnc: string, editProviderModal) {
    this.ProviderId = providerID;

    this.ProviderService.GetEditProviderData(providerIDEnc).subscribe((result) => {
      let resultObj = result as any;
      let provider = resultObj.model;
      let lists = resultObj.lists;
      this.TypesList = lists.providerTypes;

      this.EditProviderForm = new FormGroup({});
      this.EditProviderFormOptions = new FormOptions();
      this.EditProviderFormOptions.FormGroup = this.EditProviderForm
      this.EditProviderFormOptions.GetModelFunction = this.getEditProviderModel;
      this.EditProviderFormOptions.ServiceSubmitFunction = this.getEditProviderFunction;
      this.EditProviderFormOptions.PagingReference = this.pagingElement


      this.EditName = new TextBoxOptions();
      this.EditName.Name = "EditName";   /*used when call the control (important) (##1)*/
      this.EditName.LabelKey = "ProviderName";
      this.EditName.Type = InputType.Text;
      this.EditName.IsRequired = true;
      this.EditName.Value = provider.providerName;

      this.EditDescription = new TextAreaOptions();
      this.EditDescription.Name = "EditDescription";
      this.EditDescription.LabelKey = "Description";
      this.EditDescription.Value = provider.description;

      let selectedProviderType = this.TypesList.filter((item) => { return item.key == provider.typeFullName; }).map((item) => item.key)[0];

      this.EditTypeOptions = new DropdownOptions();
      this.EditTypeOptions.Name = "EditTypeOptions"
      this.EditTypeOptions.LabelKey = "ProviderType"
      this.EditTypeOptions.DataSource = this.TypesList
      this.EditTypeOptions.SingleSelection = true;
      this.EditTypeOptions.AllowSearchFilter = true;
      this.EditTypeOptions.Placeholder = "";
      this.EditTypeOptions.IsRequired = true;
      this.EditTypeOptions.SelectedItems = selectedProviderType;

      this.EditProviderTypeItemID = provider.providerTypeItemID;
      this.EditProviderOrganizationID = provider.organizationID;

      let editAttributesResult: any = this.getProviderAttributesOptions(provider.providerAttributes, false);
      this.EditProviderAttributesOptions = editAttributesResult[0];
      this.EditProviderAttributesCount = editAttributesResult[1];
      this.modalService.open(editProviderModal);
    }, (error) => {
    })

  }
  getEditProviderModel = () => {
    let paramArray: any[] = [];
    let ResultModel = this.EditProviderForm.value;
    let EditModel = new ProviderModel();

    EditModel.ID = Number(this.ProviderId);
    EditModel.ProviderName = ResultModel.EditName; //(##1)
    EditModel.Description = ResultModel.EditDescription
    EditModel.TypeFullName = ResultModel.EditTypeOptions;
    EditModel.ProviderTypeItemID = this.EditProviderTypeItemID;
    EditModel.OrganizationID = this.EditProviderOrganizationID;

    for (let j = 0; j < this.EditProviderAttributesCount; j++) {
      let editAttributeName = ResultModel["EditAttributeName" + j];
      // if (isUndefined(editAttributeName))
      //   continue;
      let editAttributeValue = ResultModel["EditAttributeValue" + j];
      let editAttributeEncrypted = ResultModel["EditAttributeEncrypted" + j];

      let providerAttr: ProviderAttributeModel = new ProviderAttributeModel();
      providerAttr.Name = editAttributeName;
      providerAttr.Value = editAttributeValue;
      providerAttr.IsEncrypted = editAttributeEncrypted;
      EditModel.ProviderAttributes.push(providerAttr);
    }
    paramArray.push(EditModel);
    return paramArray;
  }

  getEditProviderFunction = (EditModel): Observable<any> => {
    return this.ProviderService.EditProvider(EditModel)
  }

   //Delete provider
  showDeleteProviderModal(item: any, deleteProviderModal) {
    this.deleteProviderId = item.idEncrypted;
    this.utilityService.startBlockUI();
    this.modalService.open(deleteProviderModal);
    this.utilityService.stopBlockUI();

  }

  deleteProvider() {
    this.ProviderService.DeleteProvider(this.deleteProviderId).subscribe((result) => {
      this.deleteProviderId = "";
      this.modalService.dismissAll();
      let element = this.pagingElement as any;
      element.ReinitializePaging();
    }, (error) => {
    
    })

  }

  //Default provider
  showDefaultProviderModal(defaultProviderModal) {
    this.DefaultProviders = [];
    this.ProviderService.GetDefaultProviders().subscribe((result) => {
      let list = result as any;

      this.DefaultProviderForm = new FormGroup({})
      this.DefaultProviderFormOptions = new FormOptions();
      this.DefaultProviderFormOptions.FormGroup = this.DefaultProviderForm
      this.DefaultProviderFormOptions.GetModelFunction = this.getDefaultProviderModel;
      this.DefaultProviderFormOptions.ServiceSubmitFunction = this.getDefaultProviderFunction;
      this.DefaultProviderFormOptions.PagingReference = this.pagingElement

      for (let i = 0; i < list.length; i++) {
        let provider: any = list[i];

        let ProviderOption = new RadioButtonOptions();
        ProviderOption.Name = "providerOption_" + provider.providerTypeItemID;
        ProviderOption.HideLabel = true;
        ProviderOption.IsRequired = true;
        ProviderOption.ViewType = ControlLayout.Horizontal;
        let items: RadioButtonItem[] = [];
        for (let j = 0; j < provider.providers.length; j++) {
          let providerItem = provider.providers[j];
          let item = new RadioButtonItem();
          item.Text = providerItem.text;
          item.Value = providerItem.value;
          items.push(item);
          ProviderOption.Items=items;
        }

        let selectedProvider = provider.providers.filter((item) => { return item.selected == true; })[0];
        ProviderOption.Value = {
          Text: selectedProvider.text,
          Value: selectedProvider.value
        };



        let defProvider = {
          Name: provider.providerTypeItemName,
          ID: provider.providerTypeItemID,
          ProvidersOption: ProviderOption
        };
        this.DefaultProviders.push(defProvider);
      }
      this.modalService.open(defaultProviderModal);

    })
  }
  getDefaultProviderModel = () => {
    let paramArray: any[] = [];
    let ResultModel = this.DefaultProviderForm.value;
    let defaultProvidersModel: DefaultProviderModel[] = [];

    for (let i = 0; i < this.DefaultProviders.length; i++) {
      let providerID = this.DefaultProviders[i].ID;
      let selectedDefProviderID = ResultModel["providerOption_" + providerID];
      let defProvideModel: DefaultProviderModel = {
        ProviderTypeItemID: providerID,
        SelectedProviderID: Number(selectedDefProviderID),
        ProviderTypeItemName: "",
        Providers: []
      };
      defaultProvidersModel.push(defProvideModel);

    }
    paramArray.push(defaultProvidersModel);
    return paramArray;
  }

  getDefaultProviderFunction = (DefaultProviderModel): Observable<any> => {
    return this.ProviderService.SubmitDefaultProviders(DefaultProviderModel)
  }

  //Generate provider json
  generateProviderJson() {
    this.ProviderService.GenerateProviderJson().subscribe((result) => {
      let FileDTO = result as any
      const file = new Blob([FileDTO], { type: "application/json" });
      saveAs(file, "Providers.json");
    }, (error) => {
    })
  }



}
